import axios from 'axios';
import authHeader from './auth-header';
import RetryPolicy from './RetryAuthProblems'

const API_URL =  process.env.REACT_APP_API_URL; 
const axiosApiInstanceForValidation = axios.create();

axiosApiInstanceForValidation.interceptors.response.use(response => {
    return response;
}, async error => RetryPolicy(error));

class HomeService {

    getHome() {
        return axiosApiInstanceForValidation.get(API_URL + '/V1/Home', { headers: authHeader() });
    }
   
    
}

export default new HomeService();
